// This file is automatically generated. Do not edit it directly.
// Reuse the main project's Supabase client so MapleOS shares the same project and session.
import { supabase as mainSupabase } from '@/integrations/supabase/client';

// Export the main client for OS modules.
export const supabase = mainSupabase;